import { Avatar, AvatarFallback, cn } from "@myela/ui";

function initialsOf(name?: string | null, email?: string | null): string {
    const trimmed = name?.trim();
    if (trimmed) {
        const parts = trimmed.split(/\s+/).filter(Boolean);
        const first = parts[0]?.[0] ?? "";
        const second = parts.length > 1 ? parts[parts.length - 1][0] : (parts[0]?.[1] ?? "");
        return `${first}${second}`.toUpperCase();
    }
    if (email) return email.slice(0, 2).toUpperCase();
    return "?";
}

// The one user avatar: two-letter initials on the primary fill, everywhere.
export function UserAvatar({
    name,
    email,
    size = "sm",
    className,
}: {
    name?: string | null;
    email?: string | null;
    size?: "xs" | "default" | "sm" | "lg";
    className?: string;
}) {
    return (
        <Avatar
            size={size === "xs" ? "sm" : size}
            className={cn(size === "xs" && "size-5", className)}
            aria-hidden
        >
            <AvatarFallback
                className={cn(
                    "bg-primary font-medium text-primary-foreground",
                    size === "xs" ? "text-[9px]" : size === "sm" ? "text-[11px]" : "text-xs",
                )}
            >
                {initialsOf(name, email)}
            </AvatarFallback>
        </Avatar>
    );
}
